import React from "react";
import { Route, useRouteMatch } from "react-router-dom";
import SweepstakesWinnersRouter from "./SweepstakesWinners/SweepstakesWinnersRouter";
import MemberCourseLookup from "./Users/MemberCourseLookup";
import UserMerge from "./Users/UserMerge";
import PasswordResetTool from "./Users/PasswordResetTool/PasswordResetTool";
import EligibleUsers from "./Users/EligibleUsers/EligibleUsers";
import MemberLookup from "./Users/MemberLookup/MemberLookup";
import MemberEmailUnsubscribeRouter from "./MemberEmailUnsubscribe/MemberEmailUnsubscribeRouter";
import MemberEmailUnsubscribeLegacy from "./MemberEmailUnsubscribe/MemberEmailUnsubscribeLegacy";


const UsersFeaturePage = () => {
    let { path } = useRouteMatch();

    return (
        <div>
            <Route path={`${path}/member-lookup`}>
                <MemberLookup/>
            </Route> 
            <Route path={`${path}/member-course-lookup`}>
                <MemberCourseLookup />
            </Route> 
            <Route path={`${path}/sweepstakes`}>
                <SweepstakesWinnersRouter/>
            </Route>
            <Route path={`${path}/eligible-users`}>
                <EligibleUsers/>
            </Route>
            <Route path={`${path}/user-merge`}>
                <UserMerge />
            </Route>
            <Route path={`${path}/password-reset-tool`}>
                <PasswordResetTool />
            </Route>
            <Route path={`${path}/member-email-unsubscribe`}>
               <MemberEmailUnsubscribeRouter />
            </Route>
            <Route path={`${path}/member-email-unsubscribe-legacy`}>
               <MemberEmailUnsubscribeLegacy />
            </Route>
        </div>
    );
};

export default UsersFeaturePage;

